import { render } from "./ServiceFeeBuy.vue?vue&type=template&id=22ca9d75&scoped=true&ts=true"
import script from "./ServiceFeeBuy.vue?vue&type=script&lang=ts"
export * from "./ServiceFeeBuy.vue?vue&type=script&lang=ts"

import "./ServiceFeeBuy.vue?vue&type=style&index=0&id=22ca9d75&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ca9d75"]])

export default __exports__